// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YYJZM","upload":"styles_upload__UqhZ8","fileTitle":"styles_fileTitle__iiiVo","fileFormat":"styles_fileFormat__Ce0KW"};